<template>
    <section class="mx-4 my-8 bg-gray-light p-2 md:p-12">
        <p class="mb-4 text-sm text-center italic">All prices are in USD.</p>
        <div class="xl:w-4/5 xl:mx-auto md:flex md:justify-around">
            <paid-plan
                :current="current.plan"
                name="Team"
                id="v2-team"
                :monthly-price="49"
                :yearly-price="468"
                :monthly-additional-price="10"
                :yearly-additional-price="96"
                :features="available.team.features"
                @picked="pick('Team', $event)"
            ></paid-plan>
        </div>
    </section>
</template>

<script>
import SubscribeModal from '../billing/SubscribeModal';
import ChangePlanModal from '../billing/ChangePlanModal';
import UnsubscribeModal from '../billing/UnsubscribeModal.vue';

export default {
    props: {
        plan: {
            type: String,
            required: false,
        },
        endpoint: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            current: {
                plan: this.plan || null,
            },
            available: {
                team: {
                    features: [
                        { type: 'included', value: '5 seats included' },
                        { type: 'included', value: 'Snooze your inbox' },
                        { type: 'included', value: 'Multiple inbox support' },
                        { type: 'included', value: 'Activity logs' },
                        { type: 'included', value: 'Custom delivery scheduling' },
                        { type: 'included', value: 'Custom Do-Not-Disturb period' },
                        { type: 'included', value: 'VIP lists' },
                        { type: 'included', value: 'Unlimited reviewing' },
                        { type: 'bonus', value: '20% Savings' },
                        { type: 'bonus', value: 'One invoice, instead of 12' },
                    ],
                }
            },
        }
    },
    methods: {
        is(plan) {
            return plan === this.current.plan;
        },
        pick(name, plan) {
            const intent = this.identifyIntent(plan);
            
            Modal.show(intent, {propsData: {
                plan    : plan,
                name    : name,
                endpoint: this.endpoint,
			}}).then(response => {
                window.location.reload();
            }).catch(err => {console.error(err)});
        },
        identifyIntent(plan) {
            if (this.current.plan === null && plan == 'free') {
                // staying on the free plan, so, do nothing
                return null;
            }

            if (this.current.plan === null && plan !== 'free') {
                // upgrading from free to a paid plan, so, show subscribe modal
                return SubscribeModal;
            }

            if (this.current.plan !== null && plan === 'free') {
                // downgrading from paid plan to free plan, so, show cancel modal
                return UnsubscribeModal;
            }

            if (this.current.plan !== null && plan !== 'free') {
                // switching between paid plans, so, show change plan modal
                return ChangePlanModal;
            }
        }
    }
}
</script>